import React from 'react';
import CustomData from './CustomData';
import { services } from './data/serviceData';

function Service() {
  return (
    <>
      <CustomData
      data={services}
      section="My Services"
      para = "I will provide you with a high quality and clean website for your business.using this type of latest languages InshaAllah."
      />
    </>
  )
}

export default Service;